// Lightweight, framework-free SEO head manager for the SPA.
// Sets title, meta description, canonical, OG/Twitter, and injects JSON-LD.

const setMeta = (selector, attr, key, value, content) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute(content, value);
};

const setCanonical = (href) => {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

export const applySeo = ({ title, description, canonical, image, jsonLd }) => {
    if (title) {
        document.title = title;
        setMeta('meta[property="og:title"]', "property", "og:title", title, "content");
        setMeta('meta[name="twitter:title"]', "name", "twitter:title", title, "content");
    }
    if (description) {
        setMeta('meta[name="description"]', "name", "description", description, "content");
        setMeta('meta[property="og:description"]', "property", "og:description", description, "content");
        setMeta('meta[name="twitter:description"]', "name", "twitter:description", description, "content");
    }
    if (canonical) {
        setCanonical(canonical);
        setMeta('meta[property="og:url"]', "property", "og:url", canonical, "content");
    }
    if (image) {
        setMeta('meta[property="og:image"]', "property", "og:image", image, "content");
        setMeta('meta[name="twitter:image"]', "name", "twitter:image", image, "content");
    }
    // Remove previous page-level JSON-LD then add new
    document.head
        .querySelectorAll('script[data-seo="page"]')
        .forEach((n) => n.remove());
    if (jsonLd) {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo", "page");
        s.text = JSON.stringify(jsonLd);
        document.head.appendChild(s);
    }
};
